import React, { useEffect, useState } from 'react';
import { getInsuranceInvoiceList, SearchCompanyInvoice, ShowInsuranceInvocieApi } from './ApiMethods';
import { formatCustomDate, formatDate } from './CashTable';
import CustomPagination from './CustomPagination';
import { useNavigate } from 'react-router-dom';
import AppLoader from '../../../components/AppLoader';
import { FaSearch } from 'react-icons/fa';
import { Tooltip } from '@mui/material';
import { MdOutlineRemoveRedEye } from 'react-icons/md';
import toast from 'react-hot-toast';
import InvoiceFilters from './InvoiceFilters';
import InvoiceSummary from './InvoiceSummary';

const tableHeaders = [
  { name: 'Invoice Number' },
  { name: 'Date' },
  { name: 'Patient Name' },
  // { name: 'Patient Paid Amount' },
  { name: 'Company Amount' },
  { name: 'Company Vat' },
  { name: 'Company Paid Amount' },
  { name: 'File Number' },
  { name: 'Nationality' },
  { name: 'Description' },
  { name: 'Actions' }
];

function InsuranceTable() {
  const navigate = useNavigate();
  const [invoiceList, setInvoiceList] = useState(null);
  const [loading, setLoading] = useState(false);
  const [payload, setPayload] = useState({
    branch_id: '',
    company_id: '',
    customer_id: 0,
    customer_name: '',
    end_date: '',
    page: 1,
    payment_method: '',
    per_page: 10,
    start_date: ''
  });

  useEffect(() => {
    getInsuranceInvoiceList(setLoading, setInvoiceList, payload);
  }, [payload?.page, payload?.per_page]);

  const onPageChange = (newPage, newRowsPerPage) => {
    setPayload(prev => ({
      ...prev,
      page: newPage,
      per_page: newRowsPerPage
    }));
  };

  const handelShowClick = data => {
    ShowInsuranceInvocieApi(setLoading, data?.id).then(response => {
      if (response?.status === 200) {
        navigate('/receptionist/show-invoice', {
          state: { data: response?.data }
        });
      }
    });
  };

  console.log(invoiceList);

  return (
    <>
      <InvoiceFilters
        type='insurance'
        filters={payload}
        setFilters={setPayload}
        setInvoiceList={setInvoiceList}
        setLoading={setLoading}
      />
      <div className='overflow-x-auto'>
        <div className='super-git-table !p-0 !m-0'>
          <table className='table-super-git !p-0'>
            <thead className='!p-0'>
              <tr className='!p-0'>
                {tableHeaders.map((el, index) => (
                  <th className='!p-2 !text-sm !bg-[#373d45]' key={'tableHeaders_' + index}>
                    {el.name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {invoiceList?.data?.length > 0 ? (
                invoiceList?.data?.map((el, index) => (
                  <tr key={'invoiceData_' + index} className='!p-0'>
                    <td className='!p-1 !text-sm'>{el?.invoice_number}</td>
                    <td className='!p-1 !text-sm'>{formatDate(el?.date)}</td>
                    <td className='!p-1 !text-sm capitalize text-start'>{el?.customer_name}</td>
                    {/* <td className='!p-1 !text-sm'>{el?.patient_share}</td> */}
                    <td className='!p-1 !text-sm'>
                      {el?.sub_total_without_tax % 1 !== 0
                        ? el.sub_total_without_tax?.toFixed(2)
                        : el?.sub_total_without_tax}
                    </td>
                    <td className='!p-1 !text-sm'>
                      {el?.total_vat % 1 !== 0 ? el.total_vat?.toFixed(2) : el?.total_vat}
                    </td>
                    <td className='!p-1 !text-sm'>
                      {el?.sub_total_with_tax % 1 !== 0 ? el.sub_total_with_tax?.toFixed(2) : el?.sub_total_with_tax}
                    </td>
                    <td className='!p-1 !text-sm'>{el?.file_number}</td>
                    <td className='!p-1 !text-sm'>{el?.nationality}</td>
                    <td className='!p-1 !text-sm'>{el?.description}</td>

                    <td className='flex gap-2 justify-center items-center mx-2 my-auto !mt-2 !p-1'>
                      <Tooltip title='View'>
                        <div onClick={() => handelShowClick(el)} className='text-xl cursor-pointer text-green-500'>
                          <MdOutlineRemoveRedEye />
                        </div>
                      </Tooltip>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={tableHeaders.length} className='px-4 py-2 text-center text-sm text-gray-700'>
                    No invoices found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <CustomPagination
          currentPage={invoiceList?.page}
          rowsPerPage={invoiceList?.per_page}
          totalRecords={invoiceList?.total_record}
          onPageChange={onPageChange}
        />
        <InvoiceSummary filtersDetails={invoiceList} loading={loading} />
        <AppLoader setShowLoader={setLoading} showLoader={loading} />
      </div>
    </>
  );
}

export default InsuranceTable;
